import React, {useState } from 'react';
import { Dropdown, Menu } from "antd";
import styles from './scss/addkeywords.module.scss';
import { URButton } from '../../../../shared/widgets/button';
import { useSelector } from 'react-redux';
import { init_ASR } from '../../../../models/callModel';
import { URInput } from '../../../../shared/widgets/input';
import store from '../../../../context/store/store';
import { Types } from '../../../../context/action/action';
import { filterASRKey, toastInformation } from '../../../../base/callService/common';
import { addKeyword } from '../../../../base/callService/asrTTS';
/*import {addTranscriptKeyword,removeKeyword}
  from "../../../../../context/actions/socket";*/
type TranscriptContainerState ={
  visible:boolean;
  keyValue: string;
}
// type enableProps = {
//   setSharewindow: (closed: boolean) => void;
// }
export const AddKeywords = () => {
  const { closeCaption } :init_ASR = useSelector((state:init_ASR) => state);
  const { keywords } = closeCaption;
  const [getkeywordInfo, setKeywordInfo] = useState<TranscriptContainerState>
  ({ visible: false, keyValue: "" });

  const handleInputChange = (e: any) => {
    setKeywordInfo({ ...getkeywordInfo, keyValue: e.target.value });
  };


  const removeKeywords = (elem: any) => {
    //removeKeyword(elem);
    let removhighlights = keywords.filter((item:any) => item !== elem);
    store.dispatch({
      type: Types.TRANSCRIPTS_ADD_KEYWORD,
      payload: {
        keywords: removhighlights
      }
    });
    filterASRKey();
    toastInformation(elem + " Keyword removed", "success");
  };
  const handleMenuClick = (status: string) => {
    if (status === 'cancel') {
      setKeywordInfo({ ...getkeywordInfo, visible: false });
    }
    else {
      if (getkeywordInfo.keyValue !== "") {
        if (getkeywordInfo.keyValue.trim() !== "" && keywords.indexOf(getkeywordInfo.keyValue)=== -1) {
          addKeyword(keywords, getkeywordInfo.keyValue);
          filterASRKey();
          setKeywordInfo({ ...getkeywordInfo, keyValue: "" });
        }
        else { toastInformation(getkeywordInfo.keyValue + " keyword already there","failure");}
      }
      else if (getkeywordInfo.keyValue.length > 0 && getkeywordInfo.keyValue.replace(/\s/g, '').length === 0) {
        setKeywordInfo({ ...getkeywordInfo, keyValue: "" });
        toastInformation("spaces not allowed", "failure");
      }
      else { toastInformation("Please enter Something", "failure"); }
    }
  };

  const handleVisibleChange = (flag: any) => {
    setKeywordInfo({ ...getkeywordInfo, visible: flag });
  };
  const adddocument = (

    <Menu className={styles.callsSummaryView}>
      <p>Keywords</p>
      <div className={styles.callsSummarySearch}>
        <URInput className={styles.callsSummaryInput}
          name="keyValue" value={getkeywordInfo.keyValue} onChange={handleInputChange} placeHolder={"Add Keywords"}/>
      </div>
      <div className={styles.callsSummaryKewords}>
        <ul>
          {/*<li><span className={styles.summaryList}>Web</span><span className={styles.iconClose}></span></li>
          <li><span className={styles.summaryList}>Development</span><span className={styles.iconClose}></span></li>
          <li><span className={styles.summaryList}>App</span><span className={styles.iconClose}></span></li> */}
          {keywords.map((elem: any, index: any) => {
            return (
              <>
                <li key={index}><span className={styles.summaryList}>{elem}</span>
                  <span className={styles.iconClose} onClick={(e) => removeKeywords(elem)}></span></li>
              </>
            );
          })}
        </ul>
        
      </div>
      {keywords.length === 0 &&
          <div className={styles.noDataFound}> No Keyword Found</div>
      }
      <div className={styles.callsSummaryButtonView }>
        <URButton className={styles.callsSummaryLeftButton} name='Cancel' onClick={()=>handleMenuClick('cancel')} />
        <URButton className={styles.callsSummaryRightButton} name='Apply' onClick={()=>handleMenuClick('apply')}/>
      </div>
    </Menu>
  );
  return (<>
    <Dropdown placement="bottomRight" className={styles.callsSummaryBtn}
      overlay={adddocument} trigger={['click']}
      onVisibleChange={handleVisibleChange}
      visible={getkeywordInfo.visible}>
      <span className="icon_Add-call"></span>
    </Dropdown>
  </>);
};